import React from 'react';
import { AlertTriangle, CheckCircle, Info, XCircle } from 'lucide-react';
import './ConfirmDialog.css';

/**
 * ConfirmDialog Component
 * Reusable confirmation dialog for destructive or important actions
 * Composition over configuration
 */
export default function ConfirmDialog({
  title,
  message,
  variant = 'danger', // danger, warning, info, success
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  processingText = 'Processing...',
  onConfirm,
  onCancel,
  isLoading = false,
}) {
  const getIcon = () => {
    switch (variant) {
      case 'danger':
        return <XCircle size={48} className="confirm-icon-danger" />;
      case 'warning':
        return <AlertTriangle size={48} className="confirm-icon-warning" />;
      case 'success':
        return <CheckCircle size={48} className="confirm-icon-success" />;
      case 'info':
      default:
        return <Info size={48} className="confirm-icon-info" />;
    }
  };

  return (
    <div className="confirm-dialog">
      <div className="confirm-dialog-icon">
        {getIcon()}
      </div>

      <h2 className="confirm-dialog-title">{title}</h2>
      
      {message && (
        <p className="confirm-dialog-message">{message}</p>
      )}

      <div className="confirm-dialog-actions">
        <button
          className="confirm-btn confirm-btn-cancel"
          onClick={onCancel}
          disabled={isLoading}
        >
          {cancelText}
        </button>
        <button
          className={`confirm-btn confirm-btn-${variant}`}
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? processingText : confirmText}
        </button>
      </div>
    </div>
  );
}
